"use client";
import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";

export interface RatingBucket {
  stars: number;
  count: number;
  percentage: number;
}
interface RatingDistributionProps {
  distribution: RatingBucket[];
}

export function RatingDistributionCard({
  distribution,
}: RatingDistributionProps) {
  return (
    <Card className="border-border bg-card shadow-lg">
      <CardContent className="p-8">
        <h3 className="font-serif text-lg font-medium text-foreground mb-6 tracking-tight">
          Rating Distribution
        </h3>
        <div className="space-y-3">
          {distribution.map((item) => (
            <div key={item.stars} className="flex items-center gap-4">
              <div className="flex items-center gap-1 w-12">
                <span className="text-sm text-muted-foreground">
                  {item.stars}
                </span>
                <Star className="h-3 w-3 fill-yellow-400 text-yellow-400" />
              </div>
              <div className="flex-1 bg-muted rounded-full h-2">
                <div
                  className="bg-yellow-400 h-2 rounded-full transition-all duration-1000"
                  style={{ width: `${item.percentage}%` }}
                />
              </div>
              <span className="text-sm text-muted-foreground w-8">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
